/**
 * SessionExpired.contract.ts — OPERATOR IDENTITY™ Phase 1 (Build 2.06.0).
 * Published when a session check fails (cookie expired, server rejected).
 */

import type { EventContract } from '../EventContractRegistry';

export const SessionExpiredContract: EventContract = {
  name: 'SessionExpired',
  version: 1,
  description: 'Published when a session check fails (cookie expired, server rejected).',
  publishers: ['auth-event-service'],
  subscribers: [],
  fields: [],
  allowExtraFields: false,
  timestampPolicy: 'Set to Date.now() at publish time.',
  stability: 'stable',
  deprecated: false,
  example: {},
};
